import { ObservableArray } from 'mobx/lib/internal';
import { PartialDeep } from 'type-fest';

import { ImageFile, SoundFile } from 'types';

import { translate } from '../services/i18nService';


export type Theme = {
  games: {
    keno: {
      icon: ImageFile;
      borderClass: string;
      containerClass: string;
    };
    wheel: {
      icon: ImageFile;
      containerClass: string;
      outerCircleClass: string;
      arrowClass: string;
      centerClass: string;
    };
    dice: {
      icon: ImageFile;
      containerClass: string;
    };
  };
  logoImage: ImageFile;
  boost: {
    icon: ImageFile;
    buttonIcon: ImageFile;
    modalTitle: ReturnType<typeof translate>;
    timerLabel: ReturnType<typeof translate>;
    sound: SoundFile;
  };
  tipping: {
    tier1Sound: SoundFile;
    tier2Sound: SoundFile;
    tier3Sound: SoundFile;
    tier4Sound: SoundFile;
  };
  onCamAnimation?: {
    delay?: number;
    cookieNamePrefix: string;
    animBackgroundClass?: string;
    animBackground2Class?: string;
    staticBackgroundClass?: string;
    animWrapperClass?: string;
    animTextClass?: string;
    line1Text: ReturnType<typeof translate>;
    line2Text?: ReturnType<typeof translate>;
    line3Text?: ReturnType<typeof translate>;
  };
  buyTokensModal?: {
    cookieNamePrefix: string;
    titleClass?: string;
    headerClass?: string;
    title: ReturnType<typeof translate>;
    text?: ReturnType<typeof translate>;
  };
  headerCTA?: {
    cookieNamePrefix: string;
    wrapperClass?: string;
    title?: ReturnType<typeof translate>;
  };
  mobileOverlay?: {
    cookieNamePrefix: string;
    delay?: number;
    titleClass?: string;
    bodyClass?: string;
    title: ReturnType<typeof translate>;
    text: ReturnType<typeof translate>;
  };
  chatOffer?: {
    delay?: number;
    titleClass?: string;
    wrapperClass?: string;
    title?: ReturnType<typeof translate>;
    text?: ReturnType<typeof translate>;
  };
  infoStrip?: {
    titleClass?: string;
    wrapperClass?: string;
    useTimer: boolean;
    timer?: {
      digitClass?: string;
      colonClass?: string;
      labelClass?: string;
    };
    campaignSecondsLeft?: number;
    title: ReturnType<typeof translate>;
    text: ReturnType<typeof translate>;
  };
  registrationOverlay?: {
    backgroundImage: ImageFile;
    titleClass?: string;
    title: ReturnType<typeof translate>;
    text: ReturnType<typeof translate>;
  };
  drawerMenu?: {
    bodyClass?: string;
    title: ReturnType<typeof translate>;
    text: ReturnType<typeof translate>;
  };
};

export type ControlledFeaturesMap = {
  BOOST?: string;
  GAMES?: string;
  LOGO?: string;
  TIPPING?: string;
};
export type ControlledFeatureType = keyof ControlledFeaturesMap;

export type CampaignFlagsMap = {
  BOOST?: string;
  GAMES?: string;
  LOGO?: string;
  TIPPING?: string;
  ON_CAM_ANIMATION?: string;
  BUY_TOKENS_MODAL?: string;
  HEADER_CTA?: string;
  MOBILE_OVERLAY?: string;
  CHAT_OFFER?: string;
  INFO_STRIP?: string;
  REGISTRATION_OVERLAY?: string;
  DRAWER_MENU?: string;
};
export type ThemeFlagType = keyof CampaignFlagsMap;

export interface ThemeClass {
  get theme(): PartialDeep<Theme>;
}

export abstract class AbstractTheme implements ThemeClass {
  static CFS: ControlledFeaturesMap;
  static CAMPAIGN_FLAGS?: CampaignFlagsMap;

  abstract get theme(): PartialDeep<Theme>;
}

export type UserCampaign = {
  activeCampaignName: string;
  priority: number;
  campaignDetails?: {
    themeFlags?: ObservableArray<string>;
    bonusTokenPercent?: number;
    bonusTokenAmount?: number;
    goldBonusTokenPercent?: number;
  };
};
